import type { RouteObject } from 'react-router'

import { BriefPage } from '@/features/intelligence/BriefPage'

export const routes: RouteObject[] = [{ path: 'brief', element: <BriefPage /> }]
